import { Link, Navigate, useNavigate, useParams } from "react-router";
import { BackArrowIcon } from "vega-icons";

import { FeatureFlag } from "@vega-api/extended/auth/useFeatureFlag";
import { useGetConversation } from "@vega-api/generated/messaging-conversations-v1/messaging-conversations-v1";
import { ThemedIconButton } from "@vega-core/components/Buttons/ThemedIconButton";
import { Tag, TagVariants } from "@vega-core/components/Tag/Tag";
import { m } from "@vega-core/paraglide/messages";
import { LPPageContainerWithNavigation } from "@vega-modules/components/PageContainerWithNavigation/PageContainerWithNavigation";
import { useFeatureFlagGuard } from "@vega-modules/hooks/useFeatureFlagGuard";
import { CoInvestmentFullPaths, CommonPaths } from "@vega-modules/paths";
import { ConversationThread } from "@vega-modules/scenes/CoInvestments/messaging/ConversationThread";

export const LpConversationPage = () => {
  useFeatureFlagGuard(
    FeatureFlag.COINVEST_MESSAGING_VD_28584,
    CommonPaths.Home,
  );

  const { conversationId = "" } = useParams<{ conversationId: string }>();
  const navigate = useNavigate();

  const conversationQuery = useGetConversation(conversationId, {
    query: { enabled: !!conversationId },
  });

  if (!conversationId) {
    return (
      <Navigate replace to={CoInvestmentFullPaths.CoInvestmentLpMessages} />
    );
  }

  const conversation = conversationQuery.data?.data;

  const renderDealTag = () => {
    if (!conversation?.meta.dealOpportunityId) return null;

    return (
      <Link
        data-testid="coinvest-lp-conversation-deal-link"
        to={CoInvestmentFullPaths.CoInvestmentLpOverview.replace(
          ":id",
          conversation.meta.dealOpportunityId,
        )}
      >
        <Tag variant={TagVariants.Disabled}>{conversation.meta.dealName}</Tag>
      </Link>
    );
  };

  return (
    <LPPageContainerWithNavigation showNavbar={false}>
      <div className="p-4 lg:p-8">
        <div className="flex items-center gap-3">
          <ThemedIconButton
            dataTestId="coinvest-lp-conversation-back"
            icon={<BackArrowIcon />}
            onClick={() =>
              navigate(CoInvestmentFullPaths.CoInvestmentLpMessages)
            }
            size="medium"
            type="button"
          />
          <div className="flex-1">
            <h4 className="text-text/primary heading-4">
              {m.coInvestments_messages_title()}
            </h4>
            <p className="mt-1 body-base-regular text-text/secondary">
              {m.coInvestments_messages_lp_subtitle()}
            </p>
          </div>
        </div>

        <div className="mt-6 flex items-center gap-3">{renderDealTag()}</div>

        <ConversationThread
          conversationId={conversationId}
          testIdPrefix="coinvest-lp"
        />
      </div>
    </LPPageContainerWithNavigation>
  );
};
